import { useMemo } from 'react';
import formatName from 'I18n/utils/formatName';
import unescapedText from 'I18n/utils/unescapedText';
import { SellerCandidateTypename, CompanyCandidateTypename } from '../../__generated__/chirp/com/hubspot/deal/plans/rpc/DealPlansRpc';
function toNames(items) {
  return items.map(item => formatName({
    firstName: item.firstName,
    lastName: item.lastName
  }) || item.email || unescapedText('dealPlan.unknownUser'));
}
export function useOwnerCandidateGroups(ownerCandidates, contacts = []) {
  const sellers = useMemo(() => ownerCandidates.filter(c => c.__typename === SellerCandidateTypename), [ownerCandidates]);
  const buyerCompany = useMemo(() => ownerCandidates.find(c => c.__typename === CompanyCandidateTypename), [ownerCandidates]);
  const sellerNames = useMemo(() => toNames(sellers), [sellers]);
  const buyerNames = useMemo(() => toNames(contacts), [contacts]);
  return {
    sellers,
    buyerCompany,
    sellerNames,
    buyerNames
  };
}